angular.module('app').config(function (ConfigurationProvider) {
  ConfigurationProvider.write({
    about: {
      member: 'EAB',
      application: 'Navigate',
      version: {
        ui: '<DEVELOPER BUILD>',
        api: '1'
      }
    }
  });
});
